import React, { useState, useEffect } from 'react';
import './NavigationBar.css';

import Burger from './assets/menu-burger.png';
import SubMenu from './assets/submenu.png';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';




let navigationItemsPathMap = {
  1: {
    "Willkommen": "/",
    "Über Mich": "UeberMich",
    "Mein Angebot": "Ernaehrungsberatung",
    "Referenzen": "Referenzen",
    "Bescheinigungen": "AerztlicheBescheinigung",
    "Anfahrt": "Anfahrt"
  },
  2: {
    "Ernährungsberatung": "Ernaehrungsberatung",
    "Ernährungstherapie": "Ernaehrungstherapie",
    "Online": "Online",
    "Kostenübernahme": "Kostenuebernahme",
    "Ablauf": "Ablauf",
    'Betr. Gesundheitsförderung': "BetrieblicheGesundheitsfoerderung",
    "Dozenten-und Vortragtätigkeit": "Dozententaetigkeit"
  }
}


const NavigationBar = ({ setIndicatorPosition, setPagePosition, navigationItems, navNumber }) => {
  let wrapperClass = 'NavBarWrapper' + navNumber;

  // Check if the screen width is less than 50em (800px)
  const isMobile = window.innerWidth < 1500;


  // State to track whether the menu is open or closed
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [scrollOffset, setScrollOffset] = useState(0);

  const [index, setIndex] = useState(0);

  const updateScrollOffset = () => {
    setScrollOffset(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', updateScrollOffset);
    return () => {
      window.removeEventListener('scroll', updateScrollOffset);
    };
  }, []);




  const topPosition = 310 + ((navNumber - 1) * 60) - scrollOffset;

  const toggleMenu = () => {
    setScrollOffset(window.scrollY)
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = (index) => {
    setPagePosition(index + 1);
    setIndicatorPosition(index + 1);
    setIsMenuOpen(false);
  };

  const location = useLocation();

  const setMenu = () => {

    console.log(location.pathname);

    if (location.pathname === "/" && navNumber === 1) {
      setIndicatorPosition(1);
      setPagePosition(1);
      setIndex(0);
      return;
    }

    if (location.pathname === "/UeberMich" && navNumber === 1) {
      setIndicatorPosition(2);
      setPagePosition(2);
      setIndex(1);
      return;
    }

    if (location.pathname === "/Referenzen" && navNumber === 1) {
      setIndicatorPosition(4);
      setPagePosition(4);
      setIndex(3);
      return;
    }

    if (location.pathname === "/AerztlicheBescheinigung" && navNumber === 1) {
      setIndicatorPosition(5);
      setPagePosition(5);
      setIndex(4);
      return;
    }

    if (location.pathname === "/Anfahrt" && navNumber === 1) {
      setIndicatorPosition(6);
      setPagePosition(6);
      setIndex(5);
      return;
    }

    if (location.pathname === "/Online" && navNumber === 2) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;
    }
    if (location.pathname === "/Online" && navNumber === 1) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;
    }

    if (location.pathname === "/Ernaehrungsberatung" && navNumber === 2) {
      setIndicatorPosition(1);
      setPagePosition(1);
      setIndex(0);
      return;
    }
    if (location.pathname === "/Ernaehrungsberatung" && navNumber === 1) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;
    }

    if (location.pathname === "/Ernaehrungstherapie" && navNumber === 2) {
      setIndicatorPosition(2);
      setPagePosition(2);
      setIndex(1);
      return;
    }
    if (location.pathname === "/Ernaehrungstherapie" && navNumber === 1) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;
    }


    if (location.pathname === "/Kostenuebernahme" && navNumber === 2) {
      setIndicatorPosition(4);
      setPagePosition(4);
      setIndex(3);
      return;
    }
    if (location.pathname === "/Kostenuebernahme" && navNumber === 1) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;
    }

    if (location.pathname === "/Ablauf" && navNumber === 2) {
      setIndicatorPosition(5);
      setPagePosition(5);
      setIndex(4);
      return;

    }
    if (location.pathname === "/Ablauf" && navNumber === 1) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;

    }

    if (location.pathname === "/BetrieblicheGesundheitsfoerderung" && navNumber === 2) {
      setIndicatorPosition(6);
      setPagePosition(6);
      setIndex(5);
      return;

    }
    if (location.pathname === "/BetrieblicheGesundheitsfoerderung" && navNumber === 1) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;

    }

    if (location.pathname === "/Dozententaetigkeit" && navNumber === 2) {
      setIndicatorPosition(7);
      setPagePosition(7);
      setIndex(6);
      return;

    }
    if (location.pathname === "/Dozententaetigkeit" && navNumber === 1) {
      setIndicatorPosition(3);
      setPagePosition(3);
      setIndex(2);
      return;
    }

    setPagePosition(0);
    setIndicatorPosition(0);

  }


  useEffect(() => {
    setMenu();
  }, [location.pathname]);

  return (
    <div className="NavigationBar">

      {isMobile ? (

        <div className='MobileNavBarWrapper'>

          <>
            <div className="mobile-menu-icon" onClick={toggleMenu}>
              <img src={navNumber === 1 ? Burger : SubMenu} alt='Menu' />
            </div>

            <div className="mobileNavItem">
              {navigationItems[index]}
            </div>

            {isMenuOpen && (
              <div className="mobile-menu-popup" style={{ top: `${topPosition}px` }}>
                {navigationItems.map((item, index) => (
                  <div

                  >
                    <Link id="link" to={navigationItemsPathMap[navNumber][item]} onClick={() => {
                      setIsMenuOpen(false);
                      // Add navigation logic if needed
                    }}>
                      <div key={index}
                        className="mobile-popup-item"
                      >

                        {item}
                      </div>

                    </Link>
                  </div>
                ))}
              </div>
            )}



          </>

        </div>
      ) : (
        <div className={wrapperClass}>

          <>
            {navigationItems.length > 0 && (
              <Link className="welcome" to={navigationItemsPathMap[navNumber][navigationItems[0]]} onMouseOver={() => setIndicatorPosition(1)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[0]}
              </Link>
            )}
            {navigationItems.length > 1 && (
              <Link className="about" to={navigationItemsPathMap[navNumber][navigationItems[1]]} onMouseOver={() => setIndicatorPosition(2)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[1]}
              </Link>
            )}
            {navigationItems.length > 2 && (
              <Link className="offers" to={navigationItemsPathMap[navNumber][navigationItems[2]]} onMouseOver={() => setIndicatorPosition(3)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[2]}
              </Link>
            )}
            {navigationItems.length > 3 && (
              <Link className="references" to={navigationItemsPathMap[navNumber][navigationItems[3]]} onMouseOver={() => setIndicatorPosition(4)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[3]}
              </Link>
            )}
            {navigationItems.length > 4 && (
              <Link className="doctor" to={navigationItemsPathMap[navNumber][navigationItems[4]]} onMouseOver={() => setIndicatorPosition(5)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[4]}
              </Link>
            )}
            {navigationItems.length > 5 && (
              <Link className="route" to={navigationItemsPathMap[navNumber][navigationItems[5]]} onMouseOver={() => setIndicatorPosition(6)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[5]}
              </Link>
            )}
            {navigationItems.length > 6 && (
              <Link className="route" to={navigationItemsPathMap[navNumber][navigationItems[6]]} onMouseOver={() => setIndicatorPosition(7)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[6]}
              </Link>
            )}
            {navigationItems.length > 7 && (
              <div className="contactdata" to={navigationItemsPathMap[navNumber][navigationItems[7]]} onMouseOver={() => setIndicatorPosition(8)} onMouseOut={() => setIndicatorPosition(0)}>
                {navigationItems[7]}
              </div>
            )}
          </>

        </div>
      )}
    </div>
  );
};

export default NavigationBar;
